import React, { FC } from 'react'
import Link from 'next/link'
import s from './DiagnosticView.module.css'
import { ProductContent } from 'types/storyblok'
import { Button } from '@components/design'

const FREQUENCY_LABELS = {
  biweekly: 'EVERY TWO WEEKS',
  monthly: 'EVERY MONTH',
  quarterly: 'EVERY THREE MONTHS',
}

interface CallToActionProps {
  loading: boolean
  addToCart: () => void
  price: string
  story: ProductContent
  availableForSale: boolean
  frequency: string
}

const CallToAction: FC<CallToActionProps> = ({
  loading,
  addToCart,
  story,
  price,
  frequency,
  availableForSale,
}) => {
  const frequencyLabel =
    // @ts-ignore
    frequency !== 'one-time' && ` ${FREQUENCY_LABELS[frequency]}`

  return (
    <div className="text-white">
      {story && !story.requires_program && story.category != 'program' && (
        <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
          <Button
            aria-label="Add to Bag"
            type="button"
            className={s.button}
            onClick={addToCart}
            loading={loading}
            disabled={availableForSale === false}
          >
            {availableForSale === false ? 'Not Available' : 'Add to Bag'}
          </Button>
          <span className="font-semibold justify-self-center sm:justify-self-start sm:pl-10 mt-2 sm:mt-0 inline-flex">
            {price}
            {frequencyLabel}
          </span>
        </div>
      )}
      {story && story.requires_program && story.category != 'program' && (
        <div>
          <div className="text-normal my-5 text-gray-500">
            <p>
              *Pharmaceutical products are only available to members of the 
              <Link href="/products/lifeforce-membership">
                <a> Lifeforce Personalized Performance Program.</a>
              </Link>
              {'  '}($129.00/mo) and are contingent on blood tests results and
              clinician video consult.
            </p>
            <p className="mt-2">
              To qualify for the program you must reside in an eligible state
              and purchase a diagnostic bundle. ($349.00)
            </p>
          </div>
        </div>
      )}
      {story && story.category == 'program' && (
        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
            <span className="font-semibold justify-self-center sm:justify-self-start sm:pl-10 mt-2 sm:mt-0 inline-flex">
              {price}
              {frequencyLabel}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default CallToAction
